/**
 * 好用的 createElement
 *
 * @param {string} tagName 标签名字
 * @param {Object} [attrs]  可以是普通的 attr，也可以是 onClick: fn() 这种回调，特别的，style 支持传入 object
 * @param {Array<any>} [children] 可以是字符串、数字、其他节点。传 false、true、null、undefined 和空字符串将不渲染
 */
export function elt(tagName, attrs, children) {
  const el = document.createElement(tagName);
  if (attrs) {
    Object.keys(attrs).forEach(key => {
      const value = attrs[key];

      // 特殊逻辑，如果是 onClick 这种
      if (typeof value === 'function' && /^on\w/.test(key)) {
        const evtName = key.substr(2).toLowerCase();
        el.addEventListener(evtName, value, false);
        return;
      }
      if (key === 'style' && typeof value === 'object') {
        Object.keys(value).forEach(k => {
          el.style[k] = value[k];
        });
        return;
      }
      el.setAttribute(key, value);
    });
  }
  if (Array.isArray(children)) {
    children.forEach(child => {
      if (child === null || child === void 0 || typeof child === 'boolean' || child === '') return;
      if (typeof child !== 'object') el.appendChild(document.createTextNode(String(child)));else el.appendChild(child);
    });
  }
  return el;
}
//# sourceMappingURL=elt.js.map
